<template>
	<div class="sideways-content-fold" v-if="activePanel">
		<div class="portlet light bordered">
			<div class="portlet-title">
				<div class="caption">
					Assign App Access
				</div>
			</div>
			<div class="portlet-body">
				<form role="form" novalidate @submit.prevent="modifyLocation($event)">
					<div class="alert alert-danger" v-if="errorMessage.length">
					    <button class="close" data-close="alert" @click="clearError()"></button>
                        <span>{{ errorMessage }}</span>
					</div>
					<div class="form-body invite-user-form">
						<div class="margin-top-20 row search-content-4">
	      					<div class="search-table table-responsive">
	      						<table class="table table-striped table-condensed">
	      							<thead>
	      								<tr>
	      									<th></th>
	      									<th><a class="no-click font-grey-mint">Include App</a></th>
	      								</tr>
	      							</thead>
	      							<tbody>
	      								<tr v-for="app in apps">
		      								<td><h4>{{ app.app_name }}</h4></td>
		      								<td>
		      									<div class="md-checkbox">
		      										<input type="checkbox" :id="`app_access_location_${app.app_id}`" class="md-check" v-model="app.location_access">
		      										<label :for="`app_access_location_${app.app_id}`">
		      											<span></span>
		      											<span class="check"></span>
		      											<span class="box"></span>
		      										</label>
		      									</div>
		      								</td>
		      							</tr>
	      							</tbody>
	      						</table>
	      					</div>
	      				</div>
					</div>
					<div class="form-actions noborder invite-user-actions">
						<button type="button" class="btn btn-default exit-invitation-setup" @click="closePanel()"> Return To Roles Dashboard</button>
						<button type="submit" class="btn blue">Submit</button>
					</div>
				</form>
			</div>
		</div>
	</div>
</template>
<script>
import { filter, forEach } from 'lodash'
import Business from '../../../../controllers/Business'
import GlobalFunctions from '../../../../global'
import Location from '../../../../controllers/Location'
import { mapGetters } from 'vuex'

/**
 * Location App Access module is a page for editing the app access of a location.
 * @class LocationAppAccess
 * @extends Locations
 * @since 0.0.8
 */

export default {
	name: 'location-app-access',
	data () {
		return {
			activePanel: false,
			errorMessage: '',
			locationId: 0,
			apps: []
		}
	},
	/**
	 * Run on created to determine if this should be the active panel or not.
	 * @function
	 * @return {undefined}
	 * @memberof LocationAppAccess
	 * @version 0.0.8
	 */
	created () {
		if (this.$route.name === 'My Business Locations - Location App Access') {
			this.activePanel = true
			if (this.$route.params.location_id && this.$route.params.location_id !== 'undefined' && parseInt(this.$route.params.location_id) !== 0) {
				this.locationId = this.$route.params.location_id
				this.getAppList()
			} else {
				this.closePanel()
			}
		} else {
			this.activePanel = false
		}
	},
	computed: mapGetters([
		'activeBusinessId'
	]),
	methods: {
		/**
		 * To clear the current error.
		 * @function
		 * @returns {undefined}
		 * @memberof LocationAppAccess
		 * @version 0.0.6
		 */
		clearError () {
			this.errorMessage = ''
		},
		/**
		 * To check if the data is valid before submitting to the backend.
		 * @function
		 * @return {object} A promise that will validate the input form
		 * @memberof LocationAppAccess
		 * @version 0.0.8
		 */
		validateLocationData () {
			let _this = this
			return new Promise((resolve, reject) => {
				const locationAppsSelected = _this.apps.filter(app => { return app.location_access }).length >= 1

				if (!locationAppsSelected) {
					return _this.$swal({
						title: 'Are you sure?',
						html: 'Do you want to remove all app access from this location?',
						type: 'warning',
						showCancelButton: true,
						confirmButtonText: 'Update Location',
						confirmButtonColor: '#d9534f',
						cancelButtonText: 'Cancel',
						allowOutsideClick: false,
						allowEscapeKey: false,
						allowEnterKey: false,
						showLoaderOnConfirm: true
					}).then(() => {
						resolve()
					}, dismiss => {
						reject()
					})
				} else {
					resolve()
				}
			})
		},
		/**
		 * To get details for the current location.
		 * @function
		 * @return {undefined}
		 * @memberof LocationAppAccess
		 * @version 0.0.8
		 */
		getLocationDetails () {
			let _this = this

			Location.getLocationDetails(_this.locationId).then(response => {
				_this.editingLocation = response.payload

				_this.apps.forEach((app, i) => {
					_this.editingLocation.apps.forEach(locApp => {
						if (app.app_id === locApp.app_id) {
							app.location_access = true
							_this.$set(_this.apps, i, app)
						}
					})
				})
			}).catch(_this.$root.errorWrapper(e => {
				if (e.responseJSON) {
					switch (e.responseJSON.declaration) {
					case 'location_not_found':
						_this.closePanel()
						break

					default:
						// No default
					}
				}
			}))
		},
		/**
		 * To pull in a list of all available apps to be chosen from for the new location.
		 * @function
		 * @returns {object} A promise that will either return an error message or display the success screen.
		 * @memberof LocationAppAccess
		 * @version 0.0.8
		 */
		getAppList () {
			let _this = this

			return Business.getBusinessDetails(_this.activeBusinessId).then(response => {
				const defaultApps = {location_access: false}
				_this.apps = response.payload.apps

				_this.apps.forEach((apps, index, allApps) => {
					allApps[index] = Object.assign({}, apps, defaultApps)
				})

				_this.getLocationDetails()
			}).catch(_this.$root.errorWrapper(e => {
				if (e.responseJSON) {
					switch (e.responseJSON.declaration) {

					default:
						// No default
					}
				}
			}))
		},
		/**
		 * To filter the selected apps for use with the modify location endpoint
		 * @function
		 * @returns {array} An array of app ids
		 * @memberof LocationAppAccess
		 * @version 0.0.8
		 */
		formatAppData () {
			let appData = []

			let filteredApps = filter(this.apps, 'location_access')

			forEach(filteredApps, (value) => {
				appData.push(value.app_id)
			})

			return appData
		},
		/**
		 * To send the updated details of the location to the backend.
		 * @function
		 * @param {object} event - The click event that prompted this function.
		 * @returns {object} A promise that will either return an error message or display the success screen.
		 * @memberof LocationAppAccess
		 * @version 0.0.8
		 */
		modifyLocation (event) {
			let disabledButton = GlobalFunctions.disableButton(event)
			let _this = this

			this.editingLocation.apps = this.formatAppData()

			return _this.validateLocationData()
			.then(response => {
				_this.clearError()
				Location.modifyLocation(_this.editingLocation).then(response => {
					_this.closePanel()
					disabledButton.complete()
				}).catch(_this.$root.errorWrapper(e => {
					if (e.responseJSON) {
						switch (e.responseJSON.declaration) {
						case 'already_exists':
							_this.errorMessage = 'A location with this name already exists. Please choose a different name.'
							break

						default:
							// No default
						}
					}
					disabledButton.cancel()
				}))
			}).catch(reason => {
				disabledButton.cancel()
			})
		},
		/**
		 * To clear the object 'editingLocation'.
		 * @function
		 * @returns {undefined}
		 * @memberof LocationAppAccess
		 * @version 0.0.8
		 */
		clearForm () {
			this.editingLocation = {
				apps: []
			}
		},
		/**
		 * To close the location app access panel by redirecting to the dashboard
		 * @function
		 * @returns {undefined}
		 * @memberof LocationAppAccess
		 * @version 0.0.8
		 */
		closePanel () {
			this.$router.push('/app/my_business/locations')
		}
	},
	watch: {
		/**
		 * To `watch` the $route in order to determine if this panel should be showing or not
		 * @function
		 * @returns {undefined}
		 * @memberof LocationAppAccess
		 * @version 0.0.8
		 */
		'$route' () {
			if (this.$route.name === 'My Business Locations - Location App Access') {
				this.activePanel = true
				this.clearError()
				this.clearForm()
				if (this.$route.params.location_id && this.$route.params.location_id !== 'undefined' && parseInt(this.$route.params.location_id) !== 0) {
					this.locationId = this.$route.params.location_id
					this.getAppList()
				} else {
					this.closePanel()
				}
			} else {
				this.activePanel = false
			}
		}
	}
}
</script>


// WEBPACK FOOTER //
// LocationAppAccess.vue?6b789a34